import ReactPDF from "@react-pdf/renderer";
import * as React from "react";
import { Fragment } from "react";
import { TApiOrderDetails } from "../../../api/endpoints/Order";
import { User } from "../../../entities/User";
import OrderPolicy from "../../../policies/OrderPolicy";
import OrderHelpers from "../../../utils/OrderHelpers";
import LicenceItem from "./LicenceItem";

interface IProps {
  order: TApiOrderDetails;
  user: User;
  styles: ReactPDF.Styles
}

const LicenceDetails = (props: IProps) => {
  const { order, user, styles } = props;

  return (
    <Fragment>
      {
        order.small_business !== null &&
        <LicenceItem styles={styles} title="Requested Small Business Discount" value={order.small_business} />
      }

      {
        OrderPolicy.canRequestResearchLicence(user, order) &&
        <LicenceItem
          styles={styles}
          title={OrderHelpers.RESEARCH_LICENCE_LABEL_BY_VERSION_MAPPING[order.cost.version].title}
          value={order.research}
        />
      }
    </Fragment>
  )
}

export default LicenceDetails;
